import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { IJobCandidateInteraction } from 'wisestep-api';
import { SearchBarNew, WsMoreOptionButton, WsSelect } from 'wisestep-base';

import { sortOptions } from '../../../../components/filters/components/AdvanceFilterHelper';
import CardWrapper from '../../../../features/automatedEmailCampaignSettings/childRoutes/CardWrapper';
import { handleCandidateDownload } from '../../../../features/dataDownload/helper/PayloadHelper';
import { success, warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { FiltersTagList } from '../../components/filterTagList';
import { FiltersTagProp } from '../../components/filterTagList/FiltersTagList';
import {
  getUpdateJobTalentPoolQuery,
  IJobTalentPoolFormType,
  searchScopeOptions,
} from '../../utils/JobTalentPoolHelper';

import JobTalentPoolSmartFilters from './JobTalentPoolSmartFilters';

const JobTalentPoolHeader = ({
  filterTags,
  onFilterTagRemoval,
  jobTalentPoolQuery,
  updateJobTalentPoolQuery,
}: {
  filterTags: FiltersTagProp[];
  onFilterTagRemoval: (id: string) => void;
  jobTalentPoolQuery: IJobCandidateInteraction;
  updateJobTalentPoolQuery: (updatedQuery: IJobCandidateInteraction) => void;
}) => {
  const { getValues } = useFormContext();

  const navigate = useNavigate();

  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleOnClick = () => {
    const updatedQuery = {
      ...getUpdateJobTalentPoolQuery(getValues() as IJobTalentPoolFormType, jobTalentPoolQuery),
    };
    updateJobTalentPoolQuery({ ...updatedQuery });
  };

  const handleRefresh = () => updateJobTalentPoolQuery({ ...jobTalentPoolQuery });

  const handleDownload = async () => {
    const downloadStatus = await handleCandidateDownload(
      'csv',
      jobTalentPoolQuery,
      [],
      'talentpool'
    );
    if (downloadStatus === 'success') setNotification(success('Downloaded candidates'));
    else setNotification(warning('Something went wrong, Please try again.'));
  };
  const handleNavigate = () => navigate('/import-candidates/');

  const moreOptionHandlers: Record<string, () => void> = {
    'Export Candidates': handleDownload,
    'Import Candidates': handleNavigate,
    Refresh: handleRefresh,
  };

  const onMoreOptionClick = (option: string) => {
    const handler = moreOptionHandlers[option];
    if (handler) {
      handler();
    } else {
      console.warn(`No handler found for option: ${option}`);
    }
  };
  return (
    <CardWrapper sx={{ pt: 0 }}>
      <Grid display="flex" flexDirection="column" rowGap={0.5}>
        <Grid item xs={1.3}>
          <WsSelect
            name="searchScope"
            selectArray={searchScopeOptions}
            defaultValue="EVERYTHING"
            onChangeValue={handleOnClick}
          />
        </Grid>
        <Grid xs={12} display="flex" alignItems="center">
          <Grid item xs={7}>
            <SearchBarNew name="query" type="submit" />
          </Grid>
          <Grid item xs={5}>
            <Grid display="flex" columnGap={1} justifyContent="flex-end">
              <Grid item>
                <WsSelect
                  name="sort"
                  selectArray={sortOptions}
                  defaultValue="createdOn,desc"
                  onChangeValue={handleOnClick}
                />
              </Grid>
              <Grid item>
                <WsMoreOptionButton
                  items={Object.keys(moreOptionHandlers)}
                  onItemClick={(item) => onMoreOptionClick(item)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <JobTalentPoolSmartFilters
          jobTalentPoolQuery={jobTalentPoolQuery}
          updateJobTalentPoolQuery={updateJobTalentPoolQuery}
          handleOnClick={handleOnClick}
        />
        <Grid xs={12}>
          <FiltersTagList filterTags={filterTags} onClick={onFilterTagRemoval} />
        </Grid>
      </Grid>
    </CardWrapper>
  );
};

export default JobTalentPoolHeader;
